export default __webpack_public_path__ + "static/media/icon-input-success.ba718699.svg";